/**
 * ヘッダの検索ボタンを押したときに表示するモーダル
 */
import Link from "next/link"
import { useCallback, useContext, useMemo } from "react"
import Modal from "react-modal"
import routes from "../../../routes"
import { globalStoreContext } from "../../store/GlobalStore"

Modal.setAppElement("#__next")

const CreatorSearchModal: React.FC = () => {
  const { globalDispatch, globalStore } = useContext(globalStoreContext)

  const isOpen = useMemo(
    () => globalStore.ui.modal.creatorSearch,
    [globalStore.ui.modal.creatorSearch],
  )

  const handleClose = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      globalDispatch({ type: "ui/modal/creatorSearch", payload: false })
    },
    [globalDispatch],
  )

  return (
    <Modal isOpen={isOpen} className="p-modal">
      <div className="p-modal-inner">
        <div className="p-modal-contents">
          <div className="p-modal-contents-inner">
            <div className="p-modal-header">
              <p className="p-modal-title">どのクリエイターを探しますか？</p>
              <button
                className="c-close-button p-modal-close"
                onClick={handleClose}
              >
                <span className="c-close-button-icon"></span>
                <span className="c-close-button-label">閉じる</span>
              </button>
            </div>

            <div className="modal-creatorSearch">
              <div>
                <Link href={routes.creatorSearchNovelist()}>
                  <a className="c-button-secondary -full">小説家を探す</a>
                </Link>
              </div>
              <div className="u-mt-15">
                <Link href={routes.creatorSearchIllustrator()}>
                  <a className="c-button-secondary -full">
                    イラストレーターを探す
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CreatorSearchModal
